module.exports = __webpack_public_path__ + "static/media/awards_20.aa2e6bc8.jpg";